module.exports = __webpack_public_path__ + "assets/img/banner2.5181f5e6.png";